import axios from 'axios';
import { SessionResultsData } from '@/types/analytics';

const getApiBaseUrl = (): string => {
  // Use environment variable
  const apiUrl = import.meta.env.VITE_API_URL;
  if (!apiUrl) {
    throw new Error('VITE_API_URL environment variable is not set');
  }
  // Ensure we have the /api/v1 prefix
  return `${apiUrl}/api/v1`;
};

export class AnalyticsService {
  private baseURL: string;

  constructor() {
    this.baseURL = getApiBaseUrl();
  }

  /**
   * Get complete results for a survey session
   * @param sessionId - The session ID
   * @returns Session results including metrics and messages
   */
  async getSessionResults(sessionId: string): Promise<SessionResultsData> {
    try {
      const response = await axios.get<SessionResultsData>(
        `${this.baseURL}/sessions/${sessionId}/results`
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          error.response?.data?.detail || 'Failed to fetch session results'
        );
      }
      throw error;
    }
  }
}

// Export singleton instance
export const analyticsService = new AnalyticsService();
